import { CLEAR_SELECTED_CUSTOMER, FiltrerAction, SET_SELECTED_CUSTOMER, SearchCustomerQueryObjectTypes } from './types'
import {
  RESET_FILTERS,
  UPDATE_ACTIVATION_STATUS,
  UPDATE_APP_ID,
  UPDATE_ECOMMERCE_STATUS,
  UPDATE_MODULE_ID,
  UPDATE_OU_NAME,
  UPDATE_QUERY
} from './actions'

const initialState: SearchCustomerQueryObjectTypes = {
  Query: '',
  OuName: '',
  AppId: '',
  ModuleID: '',
  ActivationStatus: '',
  EcommerceStatus: '',
  SalesRep: '',
  SelectedCustomer: null
}

export function customerQueryReducer(
  state: SearchCustomerQueryObjectTypes = initialState,
  FiltrerAction: FiltrerAction
): SearchCustomerQueryObjectTypes {
  switch (FiltrerAction.type) {
    case UPDATE_QUERY:
      return { ...state, Query: FiltrerAction.payload }
    case UPDATE_MODULE_ID:
      return { ...state, ModuleID: FiltrerAction.payload }
    case UPDATE_ACTIVATION_STATUS:
      return { ...state, ActivationStatus: FiltrerAction.payload }
    case UPDATE_ECOMMERCE_STATUS:
      return { ...state, EcommerceStatus: FiltrerAction.payload }
    case UPDATE_APP_ID:
      return { ...state, AppId: FiltrerAction.payload }
    case UPDATE_OU_NAME:
      return { ...state, OuName: FiltrerAction.payload }
    case SET_SELECTED_CUSTOMER:
      return { ...state, SelectedCustomer: FiltrerAction.payload }
    case CLEAR_SELECTED_CUSTOMER:
      return { ...state, SelectedCustomer: null }
    case RESET_FILTERS:
      return {
        ...state,
        ModuleID: '',
        ActivationStatus: '',
        EcommerceStatus: ''
      }
    default:
      return state
  }
}
